export const medicalAndPedagogicalCareConst = {
  path: "/single-programs/medical-and-pedagogical-care",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — МЕДИКО-ПЕДАГОГИЧЕСКОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Медико-педагогическое дело — когда забота становится профессией</h2>
      <p>
        Эта уникальная специальность объединяет знания медицины и педагогики для подготовки специалистов, работающих с детьми, имеющими
        особенности в развитии и обучении. Студенты изучают нейропсихологию, патопсихологию, коррекционные методики и современные подходы к
        инклюзивному образованию.
      </p>
      <p>
        Программа формирует профессионалов, способных помогать детям преодолевать трудности и реализовывать потенциал в безопасной и
        поддерживающей среде.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы нейропсихологии и возрастной психиатрии</li>
        <li>Диагностика нарушений развития у детей</li>
        <li>Медицинские аспекты дефектологии</li>
        <li>Методики коррекционного и инклюзивного обучения</li>
        <li>Психология детского возраста и педагогика</li>
        <li>Коммуникация с детьми и родителями</li>
        <li>Работа с детьми с РАС, СДВГ, ЗПР, нарушениями речи и моторики</li>
        <li>Правовые и этические аспекты сопровождения детей с ОВЗ</li>
        <li>Практика в образовательных, медицинских и реабилитационных учреждениях</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Медико-педагог в школах и реабилитационных центрах</li>
        <li>Дефектолог и коррекционный педагог</li>
        <li>Специалист по работе с детьми с особыми образовательными потребностями</li>
        <li>Консультант в инклюзивных и интеграционных программах</li>
        <li>Методист или преподаватель по адаптивным образовательным программам</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>В условиях роста инклюзивного образования потребность в квалифицированных специалистах постоянно увеличивается.</p>
      <p>
        <strong>Средний доход в Европе — от €35,000 до €65,000 в год</strong> и выше в частных клиниках и центрах сопровождения.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Возможность учиться на русском или английском языке</li>
        <li>Очный или дистанционный формат обучения</li>
        <li>Практика с опытными наставниками в школах, клиниках, ЦПМСС</li>
        <li>Совмещение медицинского и педагогического подхода</li>
        <li>Поддержка студентов с первых дней обучения до трудоустройства</li>
      </ul>
      <h2>Помогать детям — больше, чем работа</h2>
      <p>
        Мы готовим профессионалов, которые умеют слышать, понимать и сопровождать ребёнка на каждом этапе развития. Это профессия сердца,
        знаний и настоящего призвания.
      </p>
      <br />
      <p className="padding-left">«Медико-педагог — это тот, кто помогает детям преодолевать границы и находить возможности.»</p>
      <h2>Как поступить?</h2>
      <p>
        Заполните онлайн-заявку и прикрепите документы. Приёмная комиссия проконсультирует вас на всех этапах и поможет оформить
        поступление.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Медико-педагогическое дело — когда забота становится профессией
    Эта уникальная специальность объединяет знания медицины и педагогики для подготовки специалистов, работающих с детьми, имеющими особенности в развитии и обучении. Студенты изучают нейропсихологию, патопсихологию, коррекционные методики и современные подходы к инклюзивному образованию.
    Программа формирует профессионалов, способных помогать детям преодолевать трудности и реализовывать потенциал в безопасной и поддерживающей среде.

    Что вы будете изучать?
    • Основы нейропсихологии и возрастной психиатрии
    • Диагностика нарушений развития у детей
    • Медицинские аспекты дефектологии
    • Методики коррекционного и инклюзивного обучения
    • Психология детского возраста и педагогика
    • Коммуникация с детьми и родителями
    • Работа с детьми с РАС, СДВГ, ЗПР, нарушениями речи и моторики
    • Правовые и этические аспекты сопровождения детей с ОВЗ
    • Практика в образовательных, медицинских и реабилитационных учреждениях

    Кем можно работать после окончания?
    • Медико-педагог в школах и реабилитационных центрах
    • Дефектолог и коррекционный педагог
    • Специалист по работе с детьми с особыми образовательными потребностями
    • Консультант в инклюзивных и интеграционных программах
    • Методист или преподаватель по адаптивным образовательным программам

    Востребованность и доход
    В условиях роста инклюзивного образования потребность в квалифицированных специалистах постоянно увеличивается.
    Средний доход в Европе — от €35,000 до €65,000 в год и выше в частных клиниках и центрах сопровождения.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Возможность учиться на русском или английском языке
    • Очный или дистанционный формат обучения
    • Практика с опытными наставниками в школах, клиниках, ЦПМСС
    • Совмещение медицинского и педагогического подхода
    • Поддержка студентов с первых дней обучения до трудоустройства

    Помогать детям — больше, чем работа
    Мы готовим профессионалов, которые умеют слышать, понимать и сопровождать ребёнка на каждом этапе развития. Это профессия сердца, знаний и настоящего призвания.
    «Медико-педагог — это тот, кто помогает детям преодолевать границы и находить возможности.»

    Как поступить?
    Заполните онлайн-заявку и прикрепите документы. Приёмная комиссия проконсультирует вас на всех этапах и поможет оформить поступление.
  `,
};
